import React from 'react';
import { Star } from 'lucide-react';

// Display stars (read-only or interactive)
const StarRating = ({ 
  rating = 0, 
  maxRating = 5, 
  size = 'md', 
  interactive = false,
  onChange = () => {},
  showCount = false,
  count = 0,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
    xl: 'h-6 w-6'
  };

  const handleClick = (index) => {
    if (interactive) {
      onChange(index + 1);
    }
  };

  return (
    <div className={`flex items-center gap-0.5 ${className}`} data-testid="star-rating">
      {[...Array(maxRating)].map((_, index) => {
        const filled = index < Math.floor(rating);
        const halfFilled = !filled && index < rating;
        
        return (
          <button
            key={index}
            type="button"
            onClick={() => handleClick(index)}
            disabled={!interactive}
            className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'} focus:outline-none`}
            data-testid={`star-${index + 1}`}
          >
            <Star
              className={`${sizeClasses[size]} ${
                filled 
                  ? 'fill-yellow-400 text-yellow-400' 
                  : halfFilled 
                    ? 'fill-yellow-400/50 text-yellow-400' 
                    : 'fill-gray-200 text-gray-300'
              }`}
            />
          </button>
        );
      })}
      {showCount && count > 0 && (
        <span className="text-sm text-gray-500 ml-1">({count})</span>
      )}
    </div>
  );
};

export default StarRating;
